import type { NavItems } from '@/types/nav';
import { use3rdPartyProductList } from '@/hooks';
import { useSportMenuActived } from '@/hooks/use-sport-menu-actived';
import { useTranslations } from 'next-intl';
import { SidebarItem } from '@/features/sidebar/components/sidebar-item';

export const SidebarThirdPartyGames = () => {
	const t = useTranslations('General');
	const { isSportActived } = useSportMenuActived();
	const  { thirdPartyGameList }  = use3rdPartyProductList();
	const gamesMenuItems: NavItems = thirdPartyGameList.filter(item => item.enable).map(item => ({
		productName: item.productName,
		href: item.href,
		className: 'side-menu__btn',
		icon: item.icon,
		iconType: item.icon === 'game-lobby' ? 'general' : 'sport',
		type: 'flexible',
		title: t(item.name),
		hasLive: item.hasLive,
		selected: isSportActived(item.href)
	}));

	return gamesMenuItems.map((item, idx) => {
		return (
			<SidebarItem
				key={idx}
				item={item}
			>
				{item.title}
			</SidebarItem>
		)
	})
};